import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  IconButton,
  Button,
  Modal,
  Popover,
} from "@mui/material";
import {
  ViewList as ViewListIcon,
  Dashboard as DashboardIcon,
  Add as AddIcon,
  Tune as TuneIcon
} from "@mui/icons-material";
import EmptyUser from "./EmptyUser";
import AddUser from "./AddUser";
import CardView from "./CardView";
import UserTable from "./UserTable";
import http from "../../utils/http-common";
import { useNavigate, useLocation } from "react-router-dom";
function Users(props) {
  const [isClicked, setIsClicked] = useState(false);
  const [emptyUser, setEmptyUser] = useState(false);
  const [cardView, setCardView] = useState(true);
  const [gridView, setGridView] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const handleClick = () => {
    setIsClicked(true);
    navigate("/home/adduser");
  };
  const handleCloseAddUser = () => {
    setIsClicked(false);
  };
  const [open, setOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const open1 = Boolean(anchorEl);
  const handleOpen = (event) => {
    setOpen(true);
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setOpen(false);
    setAnchorEl(null);
  };
  useEffect(() => {
    getUsers();
  }, []);
  useEffect(() => {
    if (location.state?.setGridView) {
      setGridView(true);
      setCardView(false);
    }
  }, [location.state]);
  const FilterModal = ({ open, handleClose }) => {
    return (
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby='filter-modal-title'
        aria-describedby='filter-modal-description'>
        <Box
          sx={{
            position: "absolute",
            top: "25%",
            left: "80%",
            transform: "translate(-25%, -50%)",
            width: 90,
            bgcolor: "background.paper",
            boxShadow: 24,
            p: 2,
            borderRadius: 1,
          }}>
          <Typography
            id='filter-modal-title'
            variant='h6'
            component='h2'
            sx={{
              fontFamily: "Inter, sans-serif",
              fontSize: "12px",
              fontWeight: 500,
              lineHeight: "14.52px",
              textAlign: "left",
            }}>
            Recent User
          </Typography>
          <Typography
            id='filter-modal-title'
            variant='h6'
            component='h2'
            sx={{
              fontFamily: "Inter, sans-serif",
              fontSize: "12px",
              fontWeight: 500,
              lineHeight: "14.52px",
              textAlign: "left",
              marginTop: "10px",
            }}>
            Existing User
          </Typography>
        </Box>
      </Modal>
    );
  };
  const [userData, setUserData] = useState([]);
  const getUsers = async () => {
    try {
      const response = await http.get("/auth_service/user/list/data");
      if (response.status === 200) {
        const currentUserName = localStorage.getItem("user_name");

        const filteredData = response.data.data;
        // Check if filteredData is empty
        if (filteredData.length === 0) {
          setCardView(false);
          setEmptyUser(true);
        } else {
          setCardView(true);
          setEmptyUser(false);
        }
  
        // Update userData state
        setUserData(filteredData);
      }
    } catch (error) {
      console.error("Error fetching data", error);
    }
  };
  const handleSortByRecentUser = () => {
    // Sort userData by createdAt in descending order
    const sortedData = [...userData].sort(
      (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
    );
    setUserData(sortedData); // Update userData with the sorted data
    handleClose(); // Close the popover or modal after sorting
  };
  const handleSortByExistingUser = () => {
    // Sort userData by createdAt in ascending order
    const sortedData = [...userData].sort(
      (a, b) => new Date(a.createdAt) - new Date(b.createdAt)
    );
    setUserData(sortedData); // Update userData with the sorted data
    handleClose(); // Close the popover or modal after sorting
  };
  return (
    <div style={{ height: "100vh" }}>
      <>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: "2px 0",
          }}>
          <Typography
            sx={{
              fontFamily: "Inter, sans-serif",
              fontSize: "20px",
              fontWeight: 600,
              lineHeight: "21px",
              textAlign: "left",
            }}>
            Stakeholders
          </Typography>
         
          <Box sx={{ display: "flex", alignItems: "center" }}>
            <IconButton
              aria-label='grid view'
              sx={{ color: "black" }}
              onClick={() => {
                setCardView(true);
                setEmptyUser(false);
                setGridView(false);
              }}>
              <DashboardIcon fontSize='small' />
            </IconButton>
            <IconButton aria-label='list view' sx={{ color: "black" }}>
              <ViewListIcon
                fontSize='small'
                onClick={() => {
                  setGridView(true);
                  setEmptyUser(false);
                  setCardView(false);
                }}
              />
            </IconButton>
            <IconButton
              aria-label='filter'
              sx={{ color: "black" }}
              onClick={handleOpen}>
              <TuneIcon fontSize='small' />
            </IconButton>
            <Button
              variant='contained'
              sx={{
                marginLeft: "16px",
                fontFamily: "Inter, sans-serif",
                textTransform: "none",
                fontWeight: 500,
                backgroundColor: "#FF2800",
                padding: "5px 10px",
                "&:hover": {
                  backgroundColor: "#FF2800", // Adjust hover color if needed
                },
              }}
              startIcon={<AddIcon />} // Adding the plus icon here
              onClick={handleClick}>
              Add
            </Button>
          </Box>
        </Box>
        <Typography
            sx={{
              fontFamily: "Inter",
              fontSize: "16px",
              fontWeight: 500,
              lineHeight: "21px",
              textAlign: "left",
            }}>
          Easily Manage Your team and collaborators for seamless project sharing.
         </Typography>
        {emptyUser && (
          <div style={{ marginTop: "10px", height: "75%" }}>
            <EmptyUser />
          </div>
        )}
        {cardView && (
          <div style={{ marginTop: "10px", height: "75%" }}>
            <CardView userData={userData} getUsers={getUsers} />
          </div>
        )}
        {gridView && !cardView && (
          <div style={{ marginTop: "10px", height: "75%" }}>
            <UserTable userData={userData} getUsers={getUsers} />
          </div>
        )}
      </>
      <Popover
        open={open1}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "center",
        }}>
        <Box
          sx={{
            width: 100, // Adjust width as needed
            bgcolor: "background.paper",
            boxShadow: 24,
            p: 2,
            borderRadius: 1,
          }}>
          <Button
            onClick={handleSortByRecentUser}
            sx={{
              fontFamily: "Inter, sans-serif",
              fontSize: "12px",
              fontWeight: 500,
              lineHeight: "14.52px",
              textAlign: "left",
              textTransform: "none", // Prevents button text from being capitalized
              color: "black", // Set the color of the button text
              padding: 0, // Remove padding to make it look like a label
              justifyContent: "flex-start", // Align text to the left
            }}>
            Recent User
          </Button>
          <Button
            onClick={handleSortByExistingUser}
            sx={{
              fontFamily: "Inter, sans-serif",
              fontSize: "12px",
              fontWeight: 500,
              lineHeight: "14.52px",
              textAlign: "left",
              marginTop: "10px",
              textTransform: "none", // Prevents button text from being capitalized
              color: "black", // Set the color of the button text
              padding: 0, // Remove padding to make it look like a label
              justifyContent: "flex-start", // Align text to the left
            }}>
            Existing User
          </Button>
        </Box>
      </Popover>
    </div>
  );
}

export default Users;
